var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 33,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1D1D1B",
  d: "M16 32.195c8.837 0 16-7.18 16-16.036S24.837.123 16 .123 0 7.303 0 16.159s7.163 16.036 16 16.036"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E43625",
  d: "M16.188 11.426a4.803 4.803 0 0 0-4.797 4.808 4.803 4.803 0 0 0 4.797 4.809 4.803 4.803 0 0 0 4.798-4.809c-.003-2.656-2.15-4.808-4.798-4.808m0 7.184a2.373 2.373 0 0 1-2.37-2.376 2.373 2.373 0 0 1 2.37-2.375 2.375 2.375 0 0 1 2.37 2.375 2.375 2.375 0 0 1-2.37 2.376"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#EE7F25",
  d: "M20.107 2.211A5.48 5.48 0 0 0 16.185.563a5.48 5.48 0 0 0-3.923 1.648z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE1B",
  d: "M29.945 20.072a5.5 5.5 0 0 0 1.645-3.931c0-1.54-.63-2.93-1.645-3.932z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#6F368B",
  d: "M2.246 12.213a5.5 5.5 0 0 0-1.644 3.932c0 1.54.63 2.93 1.644 3.931z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#3091D0",
  d: "M12.266 30.008a5.48 5.48 0 0 0 3.923 1.648 5.48 5.48 0 0 0 3.922-1.648zM20.84 5.006a5.5 5.5 0 0 0-4.649-2.57 5.5 5.5 0 0 0-4.648 2.57z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#6F368B",
  d: "M27.152 20.798a5.513 5.513 0 0 0 0-9.317z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE1B",
  d: "M5.045 11.48a5.512 5.512 0 0 0 0 9.318z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#54AD47",
  d: "M11.543 27.203a5.5 5.5 0 0 0 4.648 2.57 5.5 5.5 0 0 0 4.648-2.57z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#6F368B",
  d: "M10.728 23.931a2.72 2.72 0 0 1-2.539-2.398H5.402a5.506 5.506 0 0 0 5.307 5.188z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#EE7F25",
  d: "M23.928 21.459a2.724 2.724 0 0 1-2.393 2.545v2.793a5.506 5.506 0 0 0 5.177-5.319z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE1B",
  d: "M21.387 8.175a2.72 2.72 0 0 1 2.539 2.398h2.787a5.506 5.506 0 0 0-5.307-5.188z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#E43625",
  d: "M8.186 10.649a2.724 2.724 0 0 1 2.393-2.545V5.31a5.506 5.506 0 0 0-5.177 5.318z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE1B",
  d: "m5.197 6.012-.109 4.512-2.596.096.054-1.327s.907-2.101 2.65-3.281"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#3091D0",
  d: "m27.004 5.977.108 4.512 2.596.095-.054-1.326c0-.003-.907-2.102-2.65-3.281"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE1B",
  d: "m27.004 25.866.108-4.512 2.596-.096-.054 1.326c0 .003-.907 2.105-2.65 3.282"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#3091D0",
  d: "m5.197 25.905-.109-4.513-2.596-.095.054 1.326s.907 2.102 2.65 3.282"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#54AD47",
  d: "M6.156 5.024S8.183 2.76 9.481 2.422h1.502l-.013 2.602z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#6F368B",
  d: "M26.3 5.098s-2.027-2.264-3.325-2.602h-1.498l.012 2.602z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#E43625",
  d: "M26.3 26.992s-2.027 2.264-3.325 2.602h-1.498l.012-2.602z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#EE7F25",
  d: "M6.156 26.918s2.027 2.264 3.325 2.602h1.502l-.013-2.602z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#E43625",
  d: "M13.78 16.434h-2.354v9.38h2.354z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#EE7F25",
  d: "M13.475 10.557a2.72 2.72 0 0 1 2.714-2.58 2.72 2.72 0 0 1 2.714 2.58h2.784c-.08-2.978-2.507-5.37-5.498-5.37s-5.418 2.392-5.498 5.37z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#54AD47",
  d: "M21.621 13.423a2.72 2.72 0 0 1 2.574 2.72 2.72 2.72 0 0 1-2.574 2.72v2.79a5.51 5.51 0 0 0 5.358-5.51 5.51 5.51 0 0 0-5.358-5.51z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#3091D0",
  d: "M10.577 18.863a2.72 2.72 0 0 1-2.574-2.72 2.72 2.72 0 0 1 2.573-2.72v-2.79a5.51 5.51 0 0 0-5.357 5.51 5.51 5.51 0 0 0 5.357 5.51z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE1B",
  d: "M18.787 21.463a2.724 2.724 0 0 1-2.392 2.544v2.794a5.506 5.506 0 0 0 5.176-5.319z"
})));
export { SvgLogo as ReactComponent };
export default __webpack_public_path__ + "5e003650cca3ac526dc36e7762828c96.svg";